import { https } from "./http";
import * as types from '../../mutation_types';

const state = {
    id:'',
    header:{},
    page:1,
    currentpage:5,
    loading:false,
    search:'',
    data:{},
    add_item:false,
    added_items:[],
    update_item:new FormData(),
    return:{},
    add_item_return:{}
};
const getters = {
    id:state=>state.id,
    header:state=>state.header,
    page:state=>state.page,
    currentpage:state=>state.currentpage,
    loading:state=>state.loading,
    search:state=>state.search,
    data:state=>state.data,
    add_item:state=>state.add_item,
    added_items:state=>state.added_items,
    update_item:state=>state.update_item,
    return:state=>state.return,
    add_item_return:state=>state.add_item_return
};
const actions = {
    async fetchPrDraftHeader({commit}){
        let uri = `purchase-return-draft-header/${state.id}`;
        await https().get(uri).then(response=>{
            commit(types.PURCHASE_RETURN_DRAFT_DETAILS_HEADER,response.data);
        }).catch(error=>{
            console.log(error);
        })
    },
    async fetchPrDraftItems({commit}){
        commit(types.PURCHASE_RETURN_DRAFT_DETAILS_LOADING);
        let uri = `purchase-return-draft-detail/${state.id}?page=${state.page}&currentpage=${state.currentpage}&search=${state.search}`;
        await https().get(uri).then(response=>{
            commit(types.PURCHASE_RETURN_DRAFT_DETAILS_DATA,response.data);
            commit(types.PURCHASE_RETURN_DRAFT_DETAILS_LOADING);
        }).catch(error=>{
            console.log(error);
            commit(types.PURCHASE_RETURN_DRAFT_DETAILS_LOADING);
        })
    },
    async updatePrDraftItems({commit}){
        let uri = `purchase-return-draft-detail/${state.id}`;
        await https().post(uri,state.update_item).then(response=>{
            console.log(response);
        }).catch(error=>{
            console.log(error);
        })
    },
    async storePrDraftItems({commit,dispatch}){
        let form_data = new FormData();
        form_data.append('control_number',state.header.control_number);
        form_data.append('items',JSON.stringify(state.added_items));
        let uri = `purchase-return-draft-detail`;
        await https().post(uri,form_data).then(response=>{
            commit(types.PURCHASE_RETURN_DRAFT_DETAILS_ADD_ITEM_RETURN,response.data);
        }).catch(error=>{
            let data = {
                icon:'error',
                message:'Saving Purchase Return as Draft encountered an Error.'
            }
            commit(types.PURCHASE_RETURN_DRAFT_DETAILS_ADD_ITEM_RETURN,data);
        })
    },
    async saveAsPurchaseReturn({commit}){
        let form_data = new FormData();
        form_data.append('_method','put');
        let uri = `purchase-return-draft-header/${state.id}`;
        await https().post(uri,form_data).then(response=>{
            commit(types.PURCHASE_RETURN_DRAFT_DETAILS_RETURN,response.data);
        }).catch(error=>{
            let data = {
                icon:'error',
                message:'Posting Purchase Return encountered an Error.'
            }
            commit(types.PURCHASE_RETURN_DRAFT_DETAILS_RETURN,data);
        })
    },
};
const mutations = {
    [types.PURCHASE_RETURN_DRAFT_DETAILS_ID](state,data){
        state.id = data;
    },
    [types.PURCHASE_RETURN_DRAFT_DETAILS_PAGE](state,data){
        state.page = data;
    },
    [types.PURCHASE_RETURN_DRAFT_DETAILS_CURRENTPAGE](state,data){
        state.currentpage = data;
    },
    [types.PURCHASE_RETURN_DRAFT_DETAILS_SEARCH](state,data){
        state.search = data;
    },
    [types.PURCHASE_RETURN_DRAFT_DETAILS_LOADING](state){
        state.loading = !state.loading;
    },
    [types.PURCHASE_RETURN_DRAFT_DETAILS_DATA](state,data){
        state.data = data;
    },
    [types.PURCHASE_RETURN_DRAFT_DETAILS_ADD_ITEM](state){
        state.add_item = !state.add_item;
    },
    [types.PURCHASE_RETURN_DRAFT_DETAILS_ADDED_ITEMS](state,data){
        state.added_items = data;
    },
    [types.PURCHASE_RETURN_DRAFT_DETAILS_UPDATE_ITEM](state,data){
        state.update_item = data;
    },
    [types.PURCHASE_RETURN_DRAFT_DETAILS_HEADER](state,data){
        state.header = data;
    },
    [types.PURCHASE_RETURN_DRAFT_DETAILS_RETURN](state,data){
        state.return = data;
    },
    [types.PURCHASE_RETURN_DRAFT_DETAILS_ADD_ITEM_RETURN](state,data){
        state.add_item_return = data;
    }
};
export {
    state,getters,actions,mutations
}